module.exports = __webpack_public_path__ + "static/media/beaconManageJobs.ad7e1b4d.jpg";